import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSmallArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M12 10.571L8 6 4 10.571z",
		transform: "rotate(-0 8 8.286)"
	})
});
export default SvgSmallArrowUp;
